const name = 'inss';
const path = '/inss';

export default [
  // routes
  {
    name: `${name}-proposal`,
    path: `${path}/propostas`,
    component: () => import('@/views/INSSList.vue'),
  },
  {
    name: `${name}-consult`,
    path: `${path}/consultar`,
    component: () => import('@/views/INSSConsult.vue'),
  },

  // redirects
  // ...
];
